<template>

    <div  elevation="3" :disabled="disable" :class="{ pasifCard: disable }">
           <div v-if="disable"  style="background: white;"><span style="color: red;">Bu öğe pasif olduğundan başvuru ekranında görüntülenmeyecektir. </span></div>
    <div class="mb-2 font-weight-bold" > <span style="color: black;" v-html="label"> </span>  <span v-if="required" style="color: red;margin:0px 5px;">*</span> </div>
    <v-radio-group v-model="radioGroup" :rules="listRules" persistent-hint :hint="hint" v-bind="radioGroupProps">
        <!-- <template v-slot:label>
            <div v-html="label"></div>
        </template> -->
          <!-- <template v-slot:label>
              <p> 
                    <strong v-if="required" style="color: red;margin:0px 5px;">*</strong> <strong v-html="label"> </strong>  
                  </p>
        </template> -->
        <v-radio class="itemRadio" v-for="n in items" :key="n.id" :label="n.name" :value="n.name" :hint="hint"></v-radio>
    </v-radio-group>
</div>
    <!-- <v-card 
  elevation="3" :disabled="disable" :class="{ pasifCard: disable }"
>
 <v-card-text >






</v-card-text>
</v-card> -->

</template>
<script>
import { radioSF } from '@/plugins/FieldDataFormat.js'
import { rules } from '@/plugins/custom.js'
export default {
    data() {
        return {
            value: "",
            radioGroup: null,
            title: "",
            label: "",
            required: false,


            disable: false,
            hint: "",
            items: [],
            rules: [],
            columngosterim: false

        }
    },
    props: {
        ayar: {
            // default: '{"title":"","description":""}',
            default() {
                return radioSF;
            },
            type: Object
        },


    },
    methods: {
        dataBind(json) {
            //console.log("Vtext Json", json);
            // let ayarJson = JSON.parse(jsonStr);
            this.title = json.title;
            this.description = json.description;
            this.rules = json.rules;
            this.hint = json.hint;
            this.label = json.label;
            this.column = json.column;

            this.items = json.items;
            this.required = json.required;
            this.columngosterim = json.columngosterim;
            this.radioGroup=json.value;
        },
        sayiFilter(e) {
            const key = e.key;
            const currentValue = e.target.value;
            if (key === '.' || key === ',') {
                // Eğer zaten '-' varsa veya imleç başta değilse engelle
                if (currentValue.includes('.') || e.target.selectionStart !== 0) {
                    return;

                }
                if (currentValue.includes(',') || e.target.selectionStart !== 0) {
                    return;

                }
                e.preventDefault();
            }


            if (key === '-') {
                // Eğer zaten '-' varsa veya imleç başta değilse engelle
                if (currentValue.includes('-') || e.target.selectionStart !== 0) {
                    e.preventDefault();

                }
                return;
            }
            // Rakamlara izin ver
            if (/[\d]/.test(key)) return;

            //Eğer '-' giriliyorsa:


            // Diğer tüm karakterleri engelle
            e.preventDefault();
        }
    },
    computed: {
        listRules() {
            return this.rules.map(m => rules[m]);

        },
        // a computed getter
        radioGroupProps() {
            const props = {};
            if (!this.columngosterim) {
                props.column = true;
            } else {
                props.row = true; // yönü yatay yap
            }
            return props;
        },
        getAyar: function () {
            // `this` points to the vm instance
            return this.ayar;
        }
    },
    created() {
        this.dataBind(this.ayar);
    },
    watch: {
        ayar: {
            immediate: true,
            handler(newVal, oldVal) {
                // console.log("handler:",newVal);
                // if  (newVal.required){
                // newVal.rules.push(value => !!value || 'Bu alana boş bırakılamaz.')
                // }

                this.dataBind(newVal);
                //this.slots.forEach(slot => {
                //    if (slot.availability > 10) slot.availability = 10;
                //});
            },
            deep: true
        },radioGroup(n,o){
                this.$emit('input', n);
        }

    }
}
</script>
<style scoped>
.pasifCard{
  background-color: gray !important;
}
.itemRadio{
    margin: 15px;
}
</style>